import { useAuth } from '../Context/AuthContext'
import React, { useEffect, useState } from 'react'
import { auth, db } from '../firebaseConfig'
import classes from './UserProfile.module.css'
import { motion } from 'framer-motion'
import { useHistory } from 'react-router-dom'


function UserProfile() {
    const [post, setPost] = useState([])
    const [status, setStatus] = useState(null)
    const { loggedIn } = useAuth();
    const history = useHistory();
    useEffect(async () => {
        const unsubscribe = await db.collection('users').doc(auth.currentUser.uid).collection('userImage').orderBy('createdAt', 'desc').onSnapshot(
            (snap) => {
                let documents = [];
                snap.forEach(doc => {
                    documents.push({ ...doc.data(), id: doc.id })
                })
                setPost(documents);
            }

        )
        await db.collection('users').doc(auth.currentUser.uid).onSnapshot((snap) => {
            setStatus(snap.data())
        })


        return () => {
            unsubscribe();
        }


    }, [])
    return (
        <div className={classes.userProfile}>
            {auth.currentUser && loggedIn && <div className={classes.header}><h3>Status:</h3><h4>{status && status.status}</h4></div>}
            <div className={classes.users}>
                {post.map((user) => (
                    <div className={classes.user} key={Math.random(1 * 1000000)}>
                        <motion.img whileHover={{ opacity: 1 }} src={user.url} alt="" srcset="" />
                    </div>
                ))}
            </div>
        </div>
    )
}

export default UserProfile
